module.exports = __webpack_public_path__ + "img/maximize_focused_prelight.065583d2.png";